import { Timestamp } from 'firebase/firestore';
import { isNumber } from 'shared/utils/is-number';

export const firebaseTimestampToDate = (
  timestamp?: Timestamp | Date | null,
): Date | null => {
  if (!timestamp) {
    return null;
  }
  if (timestamp instanceof Date) {
    return timestamp;
  }

  const date = new Timestamp(timestamp.seconds, timestamp.nanoseconds).toDate();
  return isNaN(date.getTime()) ? null : date;
};

export const firebaseObjectTimestampToDate = (obj: any): any => {
  if (isNumber(obj?.seconds) && isNumber(obj?.nanoseconds)) {
    const date = new Timestamp(obj.seconds, obj.nanoseconds).toDate();
    return isNaN(date.getTime()) ? null : date;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => firebaseObjectTimestampToDate(item));
  }
  if (obj !== null && typeof obj === 'object') {
    const transformedObj: { [key: string]: any } = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        transformedObj[key] = firebaseObjectTimestampToDate(obj[key]);
      }
    }
    return transformedObj;
  }

  return obj;
};
